import React from "react";
import { useNavigate } from "react-router-dom";
import TableData from "../Partials/TableData3";
const ListSupplier = () => {
  const path = "listSupplier/Datalist";
  const deletePath='deleteSupplier'
  const navigate = useNavigate();

  // editClick is used to get id and navigate to addsupplier
   const editClick = async (item) => {
    navigate(`../addsupplier/${item._id}`);
  };

  return (
    <React.Fragment>
      <div className="add-user-container">
        <div className="headingdiv">
          <span className="componet-title">Supplier List</span>
          <div>
            <button onClick={() => navigate(-1)}>Back</button>
          </div>
        </div>
        <div className="option-btn">
          <button
            onClick={() => {
              navigate("../addsupplier");
            }}
          >
            Add New Supplier
          </button>
        </div>
     
        <TableData  path={path}  deletePath={deletePath}  editClick={editClick} />
      </div>
    </React.Fragment>
  );
};

export default ListSupplier;
